import { render } from "./EcoGinecologico.vue?vue&type=template&id=0dbdfbb1&scoped=true"
import script from "./EcoGinecologico.vue?vue&type=script&lang=js"
export * from "./EcoGinecologico.vue?vue&type=script&lang=js"

import "./EcoGinecologico.vue?vue&type=style&index=0&id=0dbdfbb1&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbdfbb1"]])

export default __exports__